import React from 'react';
import { useTheme } from 'styled-components';
import { Button } from '@sighten/beacon';
import { AngleLeftHeavy } from '@sighten/beacon/icons';

import { CloseIcon } from 'shared/components/icons/CloseIcon';
import { useTranslation } from 'react-i18next';
import { Button as LegacyButton } from '../../Button/Button';
import { HeaderStyled, HeaderText } from './MessageCenterHeader.styles';
import { ModalStyleVariant } from '../types';

type HeaderProps = {
  styleVariant: ModalStyleVariant;
  handleClose: () => void;
  handleBackClick?: () => void;
  feedScrolling: boolean;
};

export function MessageCenterHeader({
  styleVariant,
  handleClose,
  handleBackClick,
  feedScrolling,
}: HeaderProps) {
  const theme = useTheme();
  const closeIcon = () => (
    <CloseIcon size="large" color={theme.colors.iconIconPrimarySecondary1100} />
  );
  const { t } = useTranslation();

  if (styleVariant === ModalStyleVariant.SECONDARY) {
    return (
      <HeaderStyled $styleVariant={styleVariant} $feedScrolling={feedScrolling}>
        <Button kind="tertiary" leadingIcon={AngleLeftHeavy} onClick={handleBackClick}>
          Back
        </Button>
        <LegacyButton styleVariant="tertiary" Icon={closeIcon} onClick={handleClose} iconRight />
      </HeaderStyled>
    );
  }
  return (
    <HeaderStyled $styleVariant={styleVariant} $feedScrolling={feedScrolling}>
      <LegacyButton styleVariant="tertiary" Icon={closeIcon} onClick={handleClose} iconRight />
      <HeaderText as="h2">{t('inbox.header')}</HeaderText>
    </HeaderStyled>
  );
}
export default MessageCenterHeader;
